import { Box, Paper, withStyles } from "@material-ui/core";
import React from "react";
import _Footer from "./_Footer";
import _Header from "./_Header";

const styles = theme => ({
  root: {
    // height: 'calc(100vh - 56px)'
    height: 'calc(100vh - 120px)',
    backgroundColor: '#F4F4F4',
    [theme.breakpoints.down('sm')]: {
      height: 'calc(100vh - 184px)',
    }
  },
  paper: {
    display: "flex",
    // width: "55vw",
    width: 1200,
    // height: "60vh",
    height: 550,
    minHeight: "350px",
    minWidth: "300px",
    [theme.breakpoints.down('lg')]: {
      width: 900,
      height: 350,
    },
    [theme.breakpoints.down('md')]: {
      width: 800,
      height: 350,
    },
    [theme.breakpoints.down('sm')]: {
      height: "50vh",
      width: "55vw",
    },
    [theme.breakpoints.down('xs')]: {
      height: "50vh",
    },
  },
  boxstyle: {
    flex: "1",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    // paddingLeft: "10%",
    // paddingRight: "10%",
    width: "50%",
  },
  formBoxStyle: {
    paddingLeft: "10%",
    paddingRight: "10%",
  },
  image: {
    // width: "75%",
    // height: "75%",
    width: "22vw",
  },
  imageLogin: {
    height: "100%",
    width: "100%",
    borderBottomLeftRadius: 4,
    borderTopLeftRadius: 4,
  }
});

class AuthContainer extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showImage: true
    };
  }

  componentDidMount() {
    this.updateWindowDimensions();
    window.addEventListener("resize", this.updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener("resize", this.updateWindowDimensions);
  }

  updateWindowDimensions = () => {
    // this.setState({ width: window.innerWidth, height: window.innerHeight });
    if (window.innerWidth < 960 && this.state.showImage)
      this.setState({ showImage: false });
    else if (!this.state.showImage && window.innerWidth >= 960)
      this.setState({ showImage: true });
  };

  getformtype = formtype => {
    const { classes } = this.props;
    let imageUrl;
    switch (formtype) {
      case "login":
        // imageUrl = "../images/loginjourney1st.svg";
        imageUrl = "../images/imgpsh_fullsize_anim.jpg";
        break;
      case "forgot password":
        imageUrl = "../images/forgtpswd1.svg";
        break;
      case "change password":
        imageUrl = "../images/changepass.svg";
        break;
      case "enter totp":
        imageUrl = "../images/totp.svg";
        break;
      case "enter otp":
        imageUrl = "../images/enterotp.svg";
        break;
      case "set pin":
        imageUrl = "../images/setpin.svg";
        break;
      case "enter pin":
        imageUrl = "../images/setpin.svg";
        break;
      default:
        imageUrl = "../images/loginjourney1st.svg";
        break;
    }
    return (
      <img
        className={formtype === 'login' ? classes.imageLogin : classes.image}
        src={imageUrl}
        alt="default image"
      />
    );
  };

  onSubmit = (e) => {
    const { classes, formtype, onFormSubmit } = this.props;
    alert("form submit: " + formtype);
    e.preventDefault();
    // return false;
    // onFormSubmit && onFormSubmit()
  }

  render() {
    const { classes, formtype, onFormSubmit } = this.props;

    return (
      <Box >
        <_Header />
        <Box
          container="true"
          className={classes.root}
          alignItems={"center"}
          justifyContent={"center"}
          // width="100vw"
          width="100vw"
          display={"flex"}
          flex={1}
        >
          <Paper className={classes.paper} elevation={3}>
            {this.state.showImage && (
              <Box
                className={classes.boxstyle}
                style={{ flexDirection: "column", backgroundColor: "#F1F3F4", paddingLeft: 0, paddingRight: 0 }}
              >
                {this.getformtype(formtype)}
                {/* {formtype == "login" && <OtherLogins />} */}
              </Box>
            )}
            <Box className={classes.boxstyle}>
              <Box className={classes.formBoxStyle}>
                <form onSubmit={this.onSubmit}>{this.props.children}</form>
              </Box>
            </Box>
          </Paper>
        </Box>
        <_Footer />
      </Box>
    );
  }
}
export default withStyles(styles)(AuthContainer);
